import SettingsTabBase from "./SettingsTabBase.jsx";
import "../../widget/fields/SwivuColorField.jsx";
import { PERSISTENCE_STATE_KEYS } from "../../../other/constants/PersistenceStateKeys.jsx";
import { assignViewsState } from "../../../other/utils/otherUtils.jsx";
import {GRANTS} from "../../../other/constants/PrivilegeTypes.jsx";
import {STORE_KEYS} from "../../../other/constants/StoreKeys.jsx";
import {SETTING_TAB_WIDGET_KEYS} from "../../../other/constants/OtherKeys.jsx";
import { cellMenuItemRemoveRow } from "../../../other/utils/gridCellMenuUtils.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";

export class SwivuSettingsResourceTypeTab extends SettingsTabBase {
  static get $name() {
    return "SwivuSettingResourceTypeTab";
  }

  static get type() {
    return "swivusettingsresourcetypetab";
  }

  get swivuDeepLinkSlug() {
    return SETTING_TAB_WIDGET_KEYS.resourceTypeTab;
  }

  static get configurable() {
    return {
      title: "Resource Type",
      cls: "tag-grid-container",
      items: [
        {
          type: WIDGET_KEYS.swivuPreferenceStyleGrid,
          ref: "typeGrid",
          height: "100%",
          width: "100%",
          features: {
            sort: false,
            group: false,
            rowReorder: { showGrip: true },
            stripe: { disabled: true },
            cellMenu: {
              items: {
                cut: false,
                copy: false,
                paste: false,
                removeRow: cellMenuItemRemoveRow({
                  onItem: "up.onRemove",
                }),
              }
            },
          },
          columns: [
            {
              id: "type",
              text: "Resource Type",
              flex: 1,
              field: "description",
              editable: true,
              editor: {
                defaultValue: "Enter Type"
              },
              finalizeCellEdit: "up.onFinalizeCellEdit",
            },
          ],
          bbar: [
            {
              type: "button",
              icon: "b-fa b-fa-plus",
              color: "b-green"
            },
            {
              type: "button",
              icon: "b-fa b-fa-trash",
              color: "b-red"
            }
          ]
        }
      ]
    };
  }

  getStoreName() {
    return STORE_KEYS.resourceTypeStore;
  }

  assignListenersToToolbarButtons(gridWidget, store) {
    gridWidget.bbar.firstItem.removeAllListeners();
    gridWidget.bbar.lastItem.removeAllListeners();
    gridWidget.bbar.firstItem.on("click", () => this.onAdd(store, gridWidget));
    gridWidget.bbar.lastItem.on("click", () => this.onRemove());
  }

  attachState(gridWidget, widgetRef) {
    gridWidget.stateId = `b-settings-tab-${widgetRef}`;
    assignViewsState([gridWidget], this.stateProvider);
  }

  loadRecord(record, context) {
    super.loadRecord(record, context);

    const { typeGrid } = this.widgetMap;
    const store = context.project.getCrudStore(this.getStoreName());
    typeGrid.store.data = store.query(() => true, true);
    this.attachState(typeGrid, PERSISTENCE_STATE_KEYS.boardSettingResourceTypeGrid);
    this.assignListenersToToolbarButtons(typeGrid, typeGrid.store);
  }

  onAdd(store, gridWidget) {
    const lastItemOrder = store.last?.order;
    const currentItemOrder = lastItemOrder ? lastItemOrder + 1 : 0;
    const newRecord = store.createRecord({
      description: "",
      order: currentItemOrder
    });
    gridWidget.store.add(newRecord);
    gridWidget.startEditing({record: newRecord, field: "description", fitTargetContent: true});
  }

  onFinalizeCellEdit({ value, record }) {
    const cellValue = value.trim();
    if (!cellValue) return false;
    if (record.isPhantom) this.project.getCrudStore(this.getStoreName()).add(record)
    return true;
  }

  onRemove() {
    const store = this.project.getCrudStore(this.getStoreName());
    const { typeGrid } = this.widgetMap;
    const removeSelected = typeGrid.selectedRecords;
    if (removeSelected.length) {
      const selectedIds = removeSelected.map((r) => r.id);
      typeGrid.store.remove(selectedIds);
      store.remove(selectedIds);
    }
  }

  swivuCheckGrants(user) {
    if (!user.can(GRANTS.grant_one)) {
      const grid = this.widgetMap.typeGrid;
      grid.disabled = true;
      grid.readOnly = true; // readonly will prevent row reorder
      grid.bbar.items.forEach(
        (item) => (item.disabled = true)
      );
    }
  }
}

SwivuSettingsResourceTypeTab.initClass();
